import BorderCardList from 'src/component/common/layout/BorderCardList';
import DayOfWeekBorderGraphCard from 'src/component/screen/dayofweekbordergraph/DayOfWeekBorderGraphCard';

export function DayOfWeekBorderGraphScreen(): JSX.Element {
  return <BorderCardList card={DayOfWeekBorderGraphCard} />;
}
